import React from 'react';
import styled from '@emotion/styled';

type CellHeaderProps = {
  label: string;
  isHighlighted?: boolean;
  isEmphasized?: boolean;
};

const CellHeader: React.FC<CellHeaderProps> = ({ label, isHighlighted = false, isEmphasized = false }) => {
  return (
    <Wrapper isHighlighted={isHighlighted}>
      <InnerWrapper isEmphasized={isEmphasized} isShort={label.length === 2}>
        {label}
      </InnerWrapper>
    </Wrapper>
  );
};

export default CellHeader;

const Wrapper = styled.div<{ isHighlighted: boolean }>`
  display: flex;
  justify-content: end;
  margin: ${(props) => props.theme.spacing(0.5, 0, 1.5)};
  color: ${({ theme, isHighlighted }) => (isHighlighted ? theme.customOverrides.Calendar.text : theme.customOverrides.Calendar.textSecondary)};
  text-transform: uppercase;
  font-weight: 600;
  font-size: 0.857rem;
`;

const InnerWrapper = styled.div<{ isEmphasized: boolean; isShort: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 24px;
  min-width: 24px;
  ${({ isShort }) => (isShort ? 'max-width: 24px;' : '')}
  padding: ${({ theme }) => theme.spacing(0, 1)};
  border-radius: ${({ theme }) => theme.shape.borderRadius * 2.4}px;

  ${({ theme, isEmphasized }) =>
    isEmphasized
      ? `
        background: ${theme.palette.common.white};
        color: ${theme.palette.common.black};
      `
      : ''}
`;
